var $d021d50e6b315ebb$exports = {};
$d021d50e6b315ebb$exports = {
  "ascending": "\u6607\u9806",
  "ascendingSort": function ascendingSort(args) {
    return "\u5217 ".concat(args.columnName, " \u3092\u6607\u9806\u3067\u4E26\u3079\u66FF\u3048");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " \u30D4\u30AF\u30BB\u30EB");
  },
  "descending": "\u964D\u9806",
  "descendingSort": function descendingSort(args) {
    return "\u5217 ".concat(args.columnName, " \u3092\u964D\u9806\u3067\u4E26\u3079\u66FF\u3048");
  },
  "resizerDescription": "Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30B5\u30A4\u30BA\u5909\u66F4\u3092\u958B\u59CB",
  "select": "\u9078\u629E",
  "selectAll": "\u3059\u3079\u3066\u9078\u629E",
  "sortable": "\u4E26\u3079\u66FF\u3048\u53EF\u80FD\u306A\u5217"
};
export { $d021d50e6b315ebb$exports as default };